export enum LivenessStatusResponse {
  Spoof = 'Spoof',
  None = 'None',
  Uncertain = 'Uncertain',
  Live = 'Live',
  NoLive = 'NoLive',
  NoneBecauseBadQuality = 'NoneBecauseBadQuality',
  NoneBecauseFaceTooClose = 'NoneBecauseFaceTooClose',
  NoneBecauseFaceNotFound = 'NoneBecauseFaceNotFound',
  NoneBecauseFaceTooSmall = 'NoneBecauseFaceTooSmall',
  NoneBecauseAngleTooLarge = 'NoneBecauseAngleTooLarge',
  NoneBecauseImageDataError = 'NoneBecauseImageDataError',
  NoneBecauseInternalError = 'NoneBecauseInternalError',
  NoneBecauseImagePreprocessError = 'NoneBecauseImagePreprocessError',
  NoneBecauseTooManyFaces = 'NoneBecauseTooManyFaces',
  NoneBecauseFaceTooCloseToBorder = 'NoneBecauseFaceTooCloseToBorder',
  NoneBecauseFaceCropped = 'NoneBecauseFaceCropped',
  NoneBecauseLicenseError = 'NoneBecauseLicenseError',
  NoneBecauseFaceOccluded = 'NoneBecauseFaceOccluded',
}

export type ResponseAntispoof = {
  attack: boolean;
};

export enum FacialAuthenticationStatusResponse {
  None = 'None',
  Negative = 'Negative',
  Positive = 'Positive',
  NoneBecausePoseExceed = 'NoneBecausePoseExceed',
  NoneBecauseInvalidExtractions = 'NoneBecauseInvalidExtractions',
}

export enum OperationStatus {
  STARTED = 'STARTED',
  SUCCEEDED = 'SUCCEEDED',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  DENIED = 'DENIED',
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
};

export enum WidgetEventTypes {
  extractionFinish = 'ExtractionFinish',
  userCancel = 'UserCancel',
  extractionTimeout = 'ExtractionTimeout',
  errorTimeout = 'ErrorTimeout',
  timeoutButtonClick = 'TimeoutButtonClick',
  exceptionCaptured = 'ExceptionCaptured'
};


export type SendSelfieResponse = {
  data: string;
  status: number;
  succeeded: boolean;
}